import { Component, OnInit, ViewChild, ChangeDetectorRef, EventEmitter, Output, Input, ElementRef } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FeesEstimationService } from '../fees-estimation-request/fees-estimation.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { AgentService } from '../shared/services/agent.service';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { Languages, FormMode, ServiceStatus, Service, TransitType, TrueFalseOptions, Direction, TransitRequestWFSteps, PenaltyType } from 'src/app/shared/models/enums.model';
import { TransitRequestDto } from './transit-request.model';
import { first } from 'rxjs/operators';
import { TransitService } from './transit-request.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { FeesEstimationDetailsComponent } from '../fees-estimation-details/fees-estimation-details.component';
import { FeesEstimate } from '../fees-estimation-request/fees-estimate.model';
import { TransitAdminDto } from 'src/app/admin/e-services/e-booking/shared/models/transit-admin.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { AppConfig } from 'src/app/shared/services/app.config';
import { AgentPostponeDto } from 'src/app/admin/e-services/e-booking/shared/models/agent-postpone.model';
import { WFHistoryService } from 'src/app/shared/services/wfhistory.service';
import { ServiceRequestAudit } from '../shared/models/service-request-audit.model';
import { ExtraFeesDto } from 'src/app/admin/e-services/e-booking/shared/models/agent-extra-fees.model';

@Component({
  selector: 'app-transit-request',
  templateUrl: './transit-request.component.html',
  styleUrls: ['./transit-request.component.css']
})
export class TransitRequestComponent implements OnInit {
  @ViewChild('TransitTabs', { static: false }) TransitTabs: TabsetComponent;
  feesEstimationUpdated: FeesEstimate = new FeesEstimate();
  transitForm: FormGroup;
  formSubmitted: boolean = false;
  ContainerShips = AppConfig.settings.apiServer.ContainerShips;
  showContainer: boolean = false;
  currentRoute: string = '';
  showActionButtons: boolean = false;
  Status = ServiceStatus;
  penaltytypes = PenaltyType;
  sameVesselHasRequest: boolean = false;
  showDesclaimerMessage: boolean = false;
  securityLevels: GenericLookup[] = [];
  sameVesselHasTransitDate: boolean = false;
  sameVesselTransitDates: ServiceRequestAudit[] = [];
  transitPenalties: any[] = [];  // Add this line
  showPenaltiesTable: boolean = false;  // Add this line

  isApplyExtraFeesMode: boolean = false;
  isArrived: boolean = false;
  showApplyExtraFeesButton: boolean = false;

  displayedLang: Languages;
  Direction: Direction;
  transitType = TransitType;
  stepData: any;
  feesEstimationStatus: number;
  transitTypeKeys = Object.keys(this.transitType).filter(key => isNaN(Number(key)));
  yesNoRadioActive = TrueFalseOptions;
  radioActiveOptionKeys = Object.keys(this.yesNoRadioActive).filter(key => isNaN(Number(key)));
  yesNoCarryingAnimals = TrueFalseOptions;
  carryingAnimalsOptionKeys = Object.keys(this.yesNoCarryingAnimals).filter(key => isNaN(Number(key)));
  @ViewChild('transitRequest', { static: false }) transitRequestEle: ElementRef;
  public FormMode: any = FormMode;
  formMode = FormMode.Add;
  transitRequest: TransitRequestDto = new TransitRequestDto();
  private yearBuiltMaxDate: Date = new Date(Date.now());
  showRequest: boolean = false;
  CreationDate: Date;
  loggedInUser: User = new User();
  public Languages: any = Languages;
  nationalities: GenericLookup[] = [];
  feesRequestId: string;
  transitRequestId: string = '';
  responseObj: ResponseObject = new ResponseObject();
  FeesEstimateObj: FeesEstimate = new FeesEstimate();
  @ViewChild('feesRequest', { static: false }) feesRequest: FeesEstimationDetailsComponent;
  cancelTransitDto: TransitAdminDto = new TransitAdminDto();
  postPoneTransitDto: AgentPostponeDto = new AgentPostponeDto();
  extraFeesDto: ExtraFeesDto = new ExtraFeesDto();
  @Output() FeesEstimateObjValue = new EventEmitter<FeesEstimate>();
  @Output() isPaidFlag: EventEmitter<boolean> = new EventEmitter();
  @Output() latestStepId: EventEmitter<number> = new EventEmitter();
  @Output() FeesEstimationValidation = new EventEmitter<Date>();

  showCancel: boolean = false;
  requestStatus: number;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  public ServiceStatus: any = ServiceStatus;
  @Input() IsAdminMode: boolean = false;
  isTabOneValid: boolean = false;
  public isRequireModificationNotesExist: boolean = false;
  public requireModificationNotes: string = "";
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  errorIMO: any = { isError: false, errorMessage: '' };
  isErrorMessage: boolean = false;
  FeesRequestNumber: string;
  todayDate: Date = new Date(new Date().setDate(new Date().getDate()));
  showHeader: boolean = false;
  showSubmit: boolean = false;
  lockTaskErrorMessage: boolean = false;
  showTransitType: boolean = false;
  ShowTakeActions: boolean = false;
  bsValue: Date = new Date(2017, 7);
  lockTaskDoneErrorMessage: boolean = false;
  isPostponeMode: boolean = false;
  sameVesselRequestsData: TransitRequestDto[] = [];
  showCancelAction: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private lookupService: LookupService,
    private translate: TranslateService,
    private globalSrv: GlobalServices, private cd: ChangeDetectorRef,
    private transitSrv: TransitService,
    private alertService: AlertService,
    private wfhistoryService: WFHistoryService,
    private authSrevice: AuthenticationService, private route: ActivatedRoute,
    private agentSrv: AgentService, private baseRequestService: BaseRequestService, private router: Router,
    private feesSrv: FeesEstimationService) {
    this.loggedInUser = this.authSrevice.currentUserValue;
    this.displayedLang = this.globalSrv.getLanguage();
    //this.radioActiveOptionKeys = this.radioActiveOptionKeys.slice(this.radioActiveOptionKeys.length / 2);
    //// will be as input
    // this.feesRequestId = '82525227-3272-461c-aaa4-1e07741c70b3';
    // this.transitRequestId = '1712A450-F7A4-4989-B962-425E9F2DAF5D';

    if (localStorage.getItem('FeesRequestId') != undefined && this.formMode == FormMode.Add) {
      this.feesRequestId = localStorage.getItem('FeesRequestId');
      this.CheckCanApplyTransit();
      localStorage.removeItem('FeesRequestId');
      this.getFeesbaseRequest(this.feesRequestId);
    }
    else if (localStorage.getItem('TransitRequestId') != undefined) {
      this.transitRequestId = localStorage.getItem('TransitRequestId');
      localStorage.removeItem('TransitRequestId');
    }
    else if (history.state.data && history.state.data.requestId) {
      this.transitRequestId = history.state.data.requestId;

    }
    else {
      this.router.navigate(['/unAuhtorized']);
    }

  }

  ngOnInit() {
    this.currentRoute = this.route.snapshot.routeConfig?.path || '';
    if (this.currentRoute === 'transitRequest') {
      this.showActionButtons = true;
    } else {
      this.showActionButtons = false;
    }
    this.buildForm();
    this.getLookups();
    if (this.transitRequestId) {
      this.getTransitRequest();
      if (!this.loggedInUser.IsAdmin) {
        this.showHeader = true;
      }
      else {
        this.showHeader = false;
      }
    }
  }

  getTransitDateApproval() {
    // Get Step Data of Navigation Decision
    this.wfhistoryService.getByRequestIdByStepId(this.transitRequestId, TransitRequestWFSteps.TransitDateApproval).subscribe(
      (resObj: ResponseObject) => {
        if (resObj.Success) {
          this.stepData = resObj.Data["StepData"] ? JSON.parse(resObj.Data["StepData"]) : null;
          if (!this.stepData) return;
          this.requireModificationNotes = this.stepData.MoreInformation;
          if (this.requireModificationNotes && this.requireModificationNotes.trim() !== "") {
            this.isRequireModificationNotesExist = true;
          }
        }
      }
    );
  }
  selectTab(tabId: number) {
    this.TransitTabs.tabs[tabId].disabled = false;
    this.TransitTabs.tabs[tabId].active = true;
  }
  receiveTabOneValidity($event) {

    this.isTabOneValid = $event
  }
  onOpenYearBuiltCalendar(container) {

    container.yearSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.setViewMode('year');
  }
  buildForm() {
    this.transitForm = this.formBuilder.group({
      D_FWD: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      D_AFT: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      AirDraught: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      Anchors: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      ShipsCranes: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      Class: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      BuildingDate: ['', [Validators.required]],
      LastName: ['', [CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      LastFlagId: [''],
      Extensions: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      FloatingUnits: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      IMONO: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.pattern("^[0-9]{7,7}$")]],
      RegisteryCertificateDate: ['', [Validators.required, CustomValidators.dateValidator()]],
      SecurityLevelId: ['', Validators.required],
      PropellerType: ['', [Validators.required, CustomValidators.textSpaceValidator()]],
      ExtraFee: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.pattern(this.numberRegex), Validators.maxLength(150)]],
      MaxManouveringSpeed: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(150)]],
      //TransitType: ['', Validators.required],
      TransitType: [null],
      //options1: ['', Validators.required],
      IsRadioActive: ['', Validators.required],
      IsCarryingAnimals: ['', Validators.required],
      //AntipollutionService: [false, [Validators.requiredTrue]],
    });

  }


  getLookups() {
    this.lookupService.GetSecurityLevel()
      .subscribe((data: ResponseObject) => {
        this.securityLevels = data.Data.filter(p => p.IsDeleted == false) as GenericLookup[];
      });
    this.lookupService.GetNationality().subscribe(d => {
      this.nationalities = d.Data.filter(p => p.IsDeleted == false) as GenericLookup[];
    });

  }
  getLookupsWithDeleted() {
    this.lookupService.GetSecurityLevel()
      .subscribe((data: ResponseObject) => {
        this.securityLevels = data.Data as GenericLookup[];
      });
    this.lookupService.GetNationality().subscribe(d => {
      this.nationalities = d.Data as GenericLookup[];
    });

  }
  receiveFeesValue($event) {
    this.FeesEstimateObj = $event;
    if (this.FeesEstimateObj && this.FeesEstimateObj.DirectionId) {
      this.checkTransitTypeVisibility(this.FeesEstimateObj.DirectionId);
    }
    this.FeesEstimateObjValue.emit(this.FeesEstimateObj);

    if (this.FeesEstimateObj && this.FeesEstimateObj.ShipTypeId == this.ContainerShips) {
      this.showContainer = true;
    } else {
      this.showContainer = false;

      if (this.transitForm.get('TransitType')?.value === TransitType.FROMDAMIETTA) {
        this.transitForm.get('TransitType').setValue(null);
      }
    }

    setTimeout(() => {
      this.feesRequest.feesDetailsForm.patchValue({
        TransitDate: new Date(this.responseObj.Data['AgentTransitDate']),
        ETA: new Date(this.responseObj.Data['AgentETA']),
        ETATime: this.responseObj.Data['AgentETA'],
      }, { emitEvent: false });

      this.feesRequest.feesDetailsForm.get('TransitDate').updateValueAndValidity();
    }, 0);
  }

  receiveFeesEstimationValidation(event) {
    if (event === undefined) return;
    this.FeesEstimationValidation.emit(event);
  }

  get f() {
    return this.transitForm.controls;
  }

  ShowTakeActionsVisibility(StatusId: any) {

    if (StatusId == ServiceStatus.Transit_CaneledbyAgent || StatusId == ServiceStatus.Transit_CancelledByAgent_Refunded || StatusId == ServiceStatus.Transit_RequestCompeleted || StatusId == ServiceStatus.RequestIsCancelled) {
      this.ShowTakeActions = false;
    } else {
      this.ShowTakeActions = true;
    }

  }

  onSubmit() {

    // nashwa validation focus
    // const invalidElements = this.namefield.nativeElement.querySelectorAll('.ng-invalid');
    // if (invalidElements.length > 0) {
    //   invalidElements[0].focus();

    // }

    const invalidElements = this.transitRequestEle.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length > 0) {
      if (!this.isTabOneValid) {
        invalidElements[0].focus();
        this.navigateToTab(0);
        //return;
      }
      else {
        invalidElements[0].focus();
        this.navigateToTab(1);
        // return;
      }

    }
    this.formSubmitted = true;
    // stop here if form is invalid
    if (this.transitForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    if (this.feesRequest.feesDetailsForm.controls.ETA.value) {
      var selectedDate = this.feesRequest.feesDetailsForm.controls.ETA.value.toLocaleString('en-US', { year: "numeric", month: "numeric", day: "numeric" });
      var selectedTime = this.feesRequest.feesDetailsForm.controls.ETATime.value.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })
      var fullDate = selectedDate + ", " + selectedTime;
      this.feesRequest.feesDetailsForm.controls.ETA.setValue(fullDate);
    }

    //************Transit Date *************/
    let dateNow = new Date();
    var selectedTransitDate = this.feesRequest.feesDetailsForm.controls.TransitDate.value.toLocaleString('en-US');
    this.feesRequest.feesDetailsForm.controls.TransitDate.setValue(selectedTransitDate);

    //***************Registry Certificate****** */
    var selectedRegisteryDate = this.transitForm.controls.RegisteryCertificateDate.value.toLocaleString('en-US');
    this.transitForm.controls.RegisteryCertificateDate.setValue(selectedRegisteryDate);

    //**********Building Date******** */
    var selectedBuildingDate = this.transitForm.controls.BuildingDate.value.toLocaleString('en-US');
    this.transitForm.controls.BuildingDate.setValue(selectedBuildingDate);


    /*this.transitRequest.ActualTransitDate = this.feesRequest.feesDetailsForm.controls.TransitDate.value;
    this.transitRequest.ArrivalDateTime = this.feesRequest.feesDetailsForm.controls.ETA.value;*/


    this.transitRequest = this.transitForm.value;
    this.transitRequest.baseRequest = this.baseRequestDTO;
    this.transitRequest.RequestorId = this.loggedInUser.UserId
    this.transitRequest.FeesRequestId = this.feesRequestId;
    this.transitRequest.AgentTransitDate = this.feesRequest.feesDetailsForm.controls.TransitDate.value;
    this.transitRequest.AgentETA = this.feesRequest.feesDetailsForm.controls.ETA.value;
    this.transitRequest.AgentLastTransitDate = this.feesRequest.feesDetailsForm.controls.LastTransitDate.value;
    this.transitRequest.Direction = this.feesRequest.feesDetailsForm.controls.DirectionId.value;
    if (this.showTransitType == false) {
      this.transitRequest.TransitType = 1;
    }


    if (this.transitRequestId) {
      this.transitRequest.Id = this.transitRequestId;
      this.transitRequest.CreatedBy = this.loggedInUser.UserId;
      this.transitRequest.CreationDate = this.CreationDate;
      this.transitSrv.Update(this.transitRequest).pipe(first())
        .subscribe(
          (data: ResponseObject) => {

            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              this.transitForm.reset();

            }
            else if (data.ErrorMessages.find(e => e == "AlreadyHaveTransit") != null) {
              this.lockTaskErrorMessage = true;
              this.showRequest = true;
              this.globalSrv.isLoaderEnabled = false;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              //  this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);

            }

          });
    }
    else {
      this.transitSrv.add(this.transitRequest).pipe(first())
        .subscribe(
          (data: ResponseObject) => {

            if (data.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              this.transitForm.reset();

            }
            else if (data.ErrorMessages.find(e => e == "AlreadyHaveTransit") != null) {
              this.lockTaskErrorMessage = true;
              this.showRequest = true;
              this.globalSrv.isLoaderEnabled = false;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              //  this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);

            }

          });
    }



  }

  // updateTransitDates(){
  //   this.feesSrv.UpdateTransitDate(this.feesEstimationUpdated).pipe(first())
  //   .subscribe(
  //     (data: ResponseObject) => {
  //
  //       if (data.Success) {
  //         this.globalSrv.isLoaderEnabled = false;
  //         this.showRequest = true;

  //       }
  //       else {
  //         this.globalSrv.isLoaderEnabled = false;
  //         this.showRequest = false;
  //         this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);

  //       }

  //     });
  // }

  checkTransitTypeVisibility(directionId: any) {

    if (directionId == Direction.SouthBound) {
      this.showTransitType = true;

      // Add Validator dynamically
      this.transitForm.controls['TransitType'].setValidators([Validators.required]);
      this.transitForm.controls['TransitType'].updateValueAndValidity();
    } else {
      this.showTransitType = false;
      // Remove Validator and Reset value
      this.transitForm.controls['TransitType'].clearValidators();
      //this.transitForm.controls['TransitType'].setValue(1);
      this.transitForm.controls['TransitType'].updateValueAndValidity();
    }
  }
  public getbaseRequest() {
    this.baseRequestService.getBaseRequest(this.transitRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.ShowTakeActionsVisibility(this.baseRequestDTO.StatusId);
        if (this.requestStatus == ServiceStatus.Transit_MoreInformationRequiredFromAgent) {
          this.transitForm.enable();
          this.formMode = FormMode.Add;
          this.validateSubmitButton;
          this.getTransitDateApproval();
        } else {
          this.transitForm.disable();
          this.formMode = FormMode.Readonly;

        }
        this.feesRequestId = this.baseRequestDTO.ParentRequestId;
        this.getFeesbaseRequest(this.baseRequestDTO.ParentRequestId);
      });

  }
  /* public getbaseRequest() {
     this.baseRequestService.getBaseRequest(this.transitRequestId).subscribe(
       d => {
         this.baseRequestDTO = d.Data;
         this.requestStatus = this.baseRequestDTO.StatusId;
         this.feesRequestId = this.baseRequestDTO.ParentRequestId;
         this.getFeesbaseRequest(this.baseRequestDTO.ParentRequestId);
       });
   }*/
  public getFeesbaseRequest(feesRequestId) {
    this.baseRequestService.getBaseRequest(feesRequestId).subscribe(
      d => {
        this.FeesRequestNumber = d.Data.RequestNumber;
      });
  }
  public getTransitRequest() {
    this.transitSrv.get(this.transitRequestId).pipe(first()).subscribe(
      (resObj: ResponseObject) => {
        this.getLookupsWithDeleted();
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.isPaidFlag.emit(this.responseObj.Data['IsEstimatedFeesPaid']);
          this.latestStepId.emit(this.responseObj.Data['LatestStepId']);
          this.transitRequest.IsCancelled = resObj.Data['IsCancelled'];
          // Add this: Set the IsArrived flag
          this.isArrived = resObj.Data['IsArrived'] || false;
          // Show Apply Extra Fees button only if IsArrived is false and IsCancelled is false
          this.showApplyExtraFeesButton = !this.isArrived && !this.transitRequest.IsCancelled;

          this.transitForm.disable();
          this.formMode = FormMode.Readonly;
          this.transitForm.patchValue(resObj.Data);
          this.transitForm.patchValue({
            //IsRadioActive: resObj.Data['IsRadioActive'] ? 'true' : 'false',
            IsRadioActive: resObj.Data['IsRadioActive'] ? 'true' : 'false',
            IsCarryingAnimals: resObj.Data['IsCarryingAnimals'] ? 'true' : 'false',
          });
          this.transitRequest = resObj.Data as TransitRequestDto;

          this.sameVesselHasTransitDate = this.transitRequest["BaseRequest"]["ServiceRequestAudits"].length > 0 ? true : false;
          this.CreationDate = this.transitRequest["BaseRequest"]["CreationDate"];
          this.sameVesselTransitDates = this.transitRequest["BaseRequest"]["ServiceRequestAudits"];
          // Extract penalties from TransitServicePenalties
          this.transitPenalties = this.transitRequest["TransitServicePenalties"] || [];
          this.showPenaltiesTable = this.transitPenalties.length > 0 ? true : false;

          if (this.transitRequest.IsEstimatedFeesPaid == true) {
            this.showDesclaimerMessage = true;
          }
          if (this.formMode == FormMode.Readonly) {
            this.listSameVesselRequests(resObj.Data['IMONO']);
          }
          //-------Antipollution Service-------
          /*this.transitForm.patchValue({
            AntipollutionService: true,
          });*/
          //--------------------------------------
          const transitDate = new Date(resObj.Data["AgentTransitDate"]);
          const startOfToday = new Date();
          startOfToday.setHours(0, 0, 0, 0);
          this.showCancelAction = transitDate >= startOfToday? true : false;
          this.getbaseRequest();
        }
      });
  }

  listSameVesselRequests(imono) {
    this.transitSrv.GetByIMO(imono)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.sameVesselHasRequest = data.Data.length > 0 ? true : false;
            // this.sameVesselRequestsData = data.Data;
            this.sameVesselRequestsData = data.Data.filter(x => x.Id != this.transitRequestId);
            //this.historicalAdminSCNT.emit(this.sameVesselRequestsData.find(x => x.AdminSCNT)?.AdminSCNT);
          }
        });

  }

  goToTransitRequestOfSameIMONO(Id: string): void {
    localStorage.setItem('TransitRequestId', Id);
    window.open('#/transitRequest', '_blank');
  }

  cancelTransit() {
    this.globalSrv.isLoaderEnabled = true;
    this.cancelTransitDto.RequestId = this.transitRequestId;
    this.cancelTransitDto.AdminEmail = this.loggedInUser.UserName;
    this.cancelTransitDto.Direction = this.FeesEstimateObj.DirectionId;
    this.cancelTransitDto.TransitDate = this.feesRequest.feesDetailsForm.controls.TransitDate.value;
    this.transitSrv.CancelTransit(this.cancelTransitDto).pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.showCancel = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskDoneErrorMessage = true;
            this.showRequest = true;
            this.showCancel = false;
            this.globalSrv.isLoaderEnabled = false;
            this.isErrorMessage = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.showCancel = false;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]), false);
          }
        });
  }

  CheckCanApplyTransit() {
    this.agentSrv.CanApplyTransitRequest(this.loggedInUser.UserName, this.feesRequestId).pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          if (!data.Success) {
            this.router.navigate(['/unAuhtorized']);
          }
        });
  }

  getFeesByTransitId() {
    // let requestId = this.feesRequestId;
    // const navigationExtras: NavigationExtras = { state: { data: { requestId } } };
    // this.router.navigate(['/feesEstimation'], navigationExtras);

    localStorage.setItem('FeesEstRequestId', this.feesRequestId);
    window.open('#/feesEstimation', '_blank');
  }

  navigateToTab(tabId: number) {
    this.TransitTabs.tabs[tabId].disabled = false;
    this.TransitTabs.tabs[tabId].active = true;
  }

  get validateSubmitButton() {

    if (this.isPostponeMode) {
      return this.isTabOneValid;
    }
    // Normal Add Mode Logic
    if (this.isTabOneValid) {
      if (this.TransitTabs.tabs[1].disabled == false &&
        this.TransitTabs.tabs[1].active == true) {
        this.showSubmit = true;
      }
    }
    return this.showSubmit;
  }

  goToAntipollutionPage(): void {
    if (this.displayedLang == Languages.Arabic)
      window.open(AppConfig.settings.apiServer.AntipollutionFormAR, '_blank');
    else
      window.open(AppConfig.settings.apiServer.AntipollutionFormEN, '_blank');
  }
  goToAntipollutionCircular(): void {
    if (this.displayedLang == Languages.Arabic)
      window.open(AppConfig.settings.apiServer.AntipollutionCircularAR, '_blank');
    else
      window.open(AppConfig.settings.apiServer.AntipollutionCircularEN, '_blank');
  }



  getPenaltyReasonKey(penalty: any): string {
    const penaltyType = penalty.PenaltyType;

    try {
      const penaltyData = penalty.PenaltyData ? JSON.parse(penalty.PenaltyData) : null;

      switch (penaltyType) {
        case 1: // Cancellation
          return 'PENALTY_REASON_CANCELLATION_AFTER_11AM';

        case 2: // Reschedule
          if (penaltyData && penaltyData.Requested && penaltyData.Previous) {
            const requestedDate = new Date(penaltyData.Requested);
            const previousDate = new Date(penaltyData.Previous);
            return requestedDate > previousDate
              ? 'PENALTY_REASON_POSTPONE_AFTER_11AM'
              : 'PENALTY_REASON_ADVANCE_AFTER_11AM';
          }
          return 'PENALTY_REASON_RESCHEDULE_AFTER_11AM';

        case 3: // Late Booking
          return 'PENALTY_REASON_LATE_BOOKING_AFTER_11AM';

        case 4: // Additional Dues (same as Type 2)
          if (penaltyData && penaltyData.Requested && penaltyData.Previous) {
            const requestedDate = new Date(penaltyData.Requested);
            const previousDate = new Date(penaltyData.Previous);
            return requestedDate > previousDate
              ? 'PENALTY_REASON_POSTPONE_AFTER_11AM'
              : 'PENALTY_REASON_ADVANCE_AFTER_11AM';
          }
          return 'PENALTY_REASON_RESCHEDULE_AFTER_11AM';

        default:
          return 'PENALTY_REASON_UNKNOWN';
      }
    } catch (error) {
      console.error('Error parsing penalty data:', error);
      return 'PENALTY_REASON_UNKNOWN';
    }
  }


  postponeTransit() {
    this.isPostponeMode = true;
    this.showRequest = false; // Ensure form is visible

    // 1. Switch to the Tab where dates are located (Tab 0: Vessel Particulars/Fees Details)
    if (this.TransitTabs && this.TransitTabs.tabs[0]) {
      this.TransitTabs.tabs[0].active = true;
    }

    if (this.feesRequest && this.feesRequest.feesDetailsForm) {

      // --- FIX 1: Reset the submission flag so errors hide until user clicks ---
      this.feesRequest.isTabOneSubmitted = false;

      this.feesRequest.showTimepicker = false;
      const currentVal = this.feesRequest.feesDetailsForm.controls['TransitDate'].value;

      // 2. Set it as the "Forbidden Date" in the child
      if (currentVal) {
        this.feesRequest.forbiddenDate = new Date(currentVal);
        this.feesRequest.addDisabledDate(new Date(currentVal));

      }
      // 2. Logic to clear values
      this.feesRequest.isTabOneSubmitted = false;
      this.feesRequest.feesDetailsForm.controls['TransitDate'].reset();
      this.feesRequest.feesDetailsForm.controls['ETA'].reset();

      // 3. RE-CREATE Timepicker (in next tick)
      setTimeout(() => {
        this.feesRequest.showTimepicker = true;

        // Set value and enable AFTER it is re-created
        this.feesRequest.feesDetailsForm.controls['ETATime'].setValue(new Date());
        this.feesRequest.feesDetailsForm.controls['TransitDate'].enable();
        this.feesRequest.feesDetailsForm.controls['ETA'].enable();
        this.feesRequest.feesDetailsForm.controls['ETATime'].enable();

        this.feesRequest.isPostponeActive = true;
      }, 0);
    }

    // Scroll logic...
    setTimeout(() => {
      this.feesRequest.showTimepicker = true;

      const element = document.getElementById('TransitDate');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
      }
    }, 200);
  }

  submitPostpone() {
    this.alertService.clear();

    // 1. Check validity of the Fees Form (where dates are)
    if (this.feesRequest.feesDetailsForm.invalid) {
      this.feesRequest.feesDetailsForm.markAllAsTouched();
      return;
    }

    this.globalSrv.isLoaderEnabled = true;

    // 2. Prepare Dataa
    // Combine Date and Time for ETA if needed, similar to onSubmit
    if (this.feesRequest.feesDetailsForm.controls.ETA.value) {
      var selectedDate = this.feesRequest.feesDetailsForm.controls.ETA.value.toLocaleString('en-US', { year: "numeric", month: "numeric", day: "numeric" });
      var selectedTime = this.feesRequest.feesDetailsForm.controls.ETATime.value.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: true })
      var fullETA = selectedDate + ", " + selectedTime;
    }

    var selectedTransitDate = this.feesRequest.feesDetailsForm.controls.TransitDate.value.toLocaleString('en-US')

    // 3. Prepare the DTO for the postpone request
    this.postPoneTransitDto.RequestId = this.transitRequestId;
    this.postPoneTransitDto.RequestorId = this.loggedInUser.UserId
    this.postPoneTransitDto.agentTransitDate = selectedTransitDate;
    this.postPoneTransitDto.Direction = this.FeesEstimateObj.DirectionId;
    this.postPoneTransitDto.agentETA = new Date(fullETA);
    this.transitSrv.postponeTransit(this.postPoneTransitDto).pipe(first())
      .subscribe({
        next: (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = false;
            this.isPostponeMode = false;

            // Re-disable fields
            this.feesRequest.feesDetailsForm.controls['TransitDate'].disable();
            this.feesRequest.feesDetailsForm.controls['ETA'].disable();
            this.feesRequest.feesDetailsForm.controls['ETATime'].disable();

            //Turn off the red border ---
            this.feesRequest.isPostponeActive = false;
            //this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGE'), false);
          } else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
          }
        },
        error: (error) => {
          this.globalSrv.isLoaderEnabled = false;
          this.isErrorMessage = true;
          console.error(error);
        }
      });
  }

  applyExtraFees() {
    this.isApplyExtraFeesMode = true;
    // Disable all form controls
    this.transitForm.disable();
    this.feesRequest.feesDetailsForm.disable();

    // Enable only ExtraFee field
    this.transitForm.get('ExtraFee').enable();

    // Clear any previous value to allow new entry
    this.transitForm.get('ExtraFee').reset();

    // --- FIX: switch to the tab that actually contains ExtraFee ---
    if (this.TransitTabs && this.TransitTabs.tabs[1]) {
      this.TransitTabs.tabs[1].disabled = false; // in case isTabOneValid is false in readonly mode
      this.TransitTabs.tabs[1].active = true;
    }

    // Scroll to ExtraFee field
    setTimeout(() => {

      const element = document.getElementById('ExtraFee');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.focus();
      }
    }, 200);
  }

  submitExtraFees() {
    // Validate ExtraFee field
    if (this.transitForm.get('ExtraFee').invalid) {
      this.alertService.error(this.translate.instant('FRONT_USER.This_Field_Is_Required'), false);
      return;
    }

    const extraFeeValue = this.transitForm.get('ExtraFee').value;

    if (!extraFeeValue || extraFeeValue.trim() === '') {
      this.alertService.error(this.translate.instant('FRONT_USER.This_Field_Is_Required'), false);
      return;
    }

    this.globalSrv.isLoaderEnabled = true;
    this.alertService.clear();

    // Prepare ExtraFeesDto using the model

    this.extraFeesDto.RequestId = this.transitRequestId?.toString();
    this.extraFeesDto.ExtraFee = extraFeeValue;
    this.extraFeesDto.ModifiedBy = this.loggedInUser.UserId?.toString();
    this.extraFeesDto.RequestorId = this.FeesEstimateObj.RequestorId?.toString();
    this.extraFeesDto.Direction = this.FeesEstimateObj.DirectionId;


    // Call service to update extra fees
    this.transitSrv.updateExtraFees(this.extraFeesDto).pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          this.globalSrv.isLoaderEnabled = false;

          if (data.Success) {
            this.alertService.success(this.translate.instant('FRONT_USER.SUCCESS_MESSAGE'), false);
            this.showRequest = true;
            this.isErrorMessage = false;
            this.isApplyExtraFeesMode = false;

            // Re-enable all fields in readonly mode
            this.transitForm.disable();
            this.feesRequest.feesDetailsForm.disable();

            // Refresh the transit request to get updated data
            setTimeout(() => {
              this.getTransitRequest();
            }, 1000);
          } else {
            this.alertService.error(
              this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + data.ErrorMessages[0]),
              false
            );
            this.isErrorMessage = true;

            // Re-enable ExtraFee for retry
            this.transitForm.get('ExtraFee').enable();
          }
        },
        (error) => {
          this.globalSrv.isLoaderEnabled = false;
          this.alertService.error('An error occurred', false);
          this.isErrorMessage = true;
          this.transitForm.get('ExtraFee').enable();
        }
      );
  }
}
